import { render, staticRenderFns } from "./search.vue?vue&type=template&id=0b39cfdd&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b39cfdd')) {
      api.createRecord('0b39cfdd', component.options)
    } else {
      api.reload('0b39cfdd', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=0b39cfdd&", function () {
      api.rerender('0b39cfdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/search.vue"
export default component.exports